export const TABULATOR = {
  ROW_HEIGHT: 36,
  MICRO_ROW_HEIGHT: 50,
  HEIGHT: 'calc(100vh - 17rem)',
}